import React from "react";
import skillSTY from "./skillSTY.css";

const titleStyle = {
    mx: 'auto',
    color: '#457b9d',
    marginBottom: '40px'
   
}
const Skills = props =>(
    <section>
        <h3 id="skillstitle"style={{marginLeft: '135px', color:  '#457b9d', marginTop: '40px'}}>skills</h3>
    <div id="skills" style={{
        marginRight: '135px', marginLeft: '135px',
        marginTop: '40px', marginBottom: '40px', 
        borderStyle: "solid", borderRadius: '0.5%', 
        borderColor: '#457b9d'}}>
            
<p>revelant skills:</p>
<ul>
    <li>strongest languages: C++, Javascript, Python, CSS, Swift, HTML, React</li>
    <li>theory: data structures, algorithms, 
        object-oriented programming, programming languages</li>
    <li>relevant courses: data structures, algorithms, discrete structures, multi-variable calculus</li>
</ul>
<p>past experience:</p>
<ul>
    <li>currently part of the Finance Staff at USA UCLA Elections Board (2021-PRESENT)</li>
    <li>helped tutor and mentor students of surrounding 
        elementary schools in subjects such as: mathematics, english, science, and computer science (2019-2020)</li>
    <li>participated in ACM Hack (2021-PRESENT)</li>
    <li>participated in ACM Teach LA (2022-PRESENT)</li>

</ul>
    </div>
    <hr></hr>
    </section>
)

export default Skills;